export default __webpack_public_path__ + "static/media/promo_03.19ff226a.jpg";